import * as ed from "@noble/ed25519";
import { sha256, sha512 } from "@noble/hashes/sha2.js";

// Ensure synchronous Ed25519 verification is available.
ed.hashes.sha512 = sha512;

const hexToBytes = (h) => {
  const clean = (h || "").trim();
  const out = new Uint8Array(clean.length / 2);
  for (let i = 0; i < out.length; i++) {
    out[i] = parseInt(clean.substr(i * 2, 2), 16);
  }
  return out;
};

function ok(sigHex, msgBytes, pubHex) {
  if (!sigHex || !pubHex) return false;
  try {
    return ed.verify(hexToBytes(sigHex), msgBytes, hexToBytes(pubHex));
  } catch {
    return false;
  }
}

// Verify an audit entry's signatures entirely in the browser, in real time.
// governor + auditor sign the canonical payload bytes; operator signs the
// SHA-256 of its own payload.
export function verifyEntry(e) {
  const enc = new TextEncoder();
  const canon = enc.encode(e.canonical_payload || "");
  const governor = ok(e.governor_signature, canon, e.governor_pubkey);
  const auditor = ok(e.auditor_signature, canon, e.auditor_pubkey);
  let operator = null;
  if (e.operator_signature && e.operator_payload && e.operator_pubkey) {
    operator = ok(e.operator_signature, sha256(enc.encode(e.operator_payload)), e.operator_pubkey);
  }
  const valid = governor && auditor && operator !== false;
  return { governor, auditor, operator, valid };
}
